"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./Typography"));
var Typography_1 = require("./Typography");
exports.default = Typography_1.default;
//# sourceMappingURL=index.js.map